import { render, staticRenderFns } from "./Destinations2.vue?vue&type=template&id=ea79c17a&scoped=true&lang=pug&"
import script from "./Destinations2.vue?vue&type=script&lang=js&"
export * from "./Destinations2.vue?vue&type=script&lang=js&"
import style0 from "./Destinations2.vue?vue&type=style&index=0&id=ea79c17a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea79c17a",
  null
  
)

export default component.exports